import axios from 'axios';
import { getAccessToken } from './shared';
import { showWarningSnackbar } from '../components/snackBar/snakbar';
import { axiosInstanceForLambda } from './Axios';
import API_ENDPOINTS from '../apiEndpoints';

export const FetchGstInDetails = async (gstin) => {
  try {
    const options = {
      method: 'GET',
      url: `${API_ENDPOINTS.REACT_APP_FETCH_GSTIN_URL}?gstin=${gstin}`,
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    };

    const response = await axiosInstanceForLambda(options);
    return response;
  } catch (error) {
    console.log(error, 'error');

    const errorData = error?.response?.data || {};
    const errorCode = errorData?.error_cd;

    const cachedMessage = errorData?.message || errorData?.errorMessage || errorData?.error;

    if (errorCode === 'F08000' || errorCode === 'SWEB_9035') {
      showWarningSnackbar('GSTIN is NOT valid. Please recheck');
    } else if (error?.code === 'ERR_NETWORK' || !error?.response) {
      showWarningSnackbar(cachedMessage || 'Network error. Please check your internet connection');
    } else if (cachedMessage) {
      showWarningSnackbar(cachedMessage);
    } else {
      showWarningSnackbar('GST portal service is temporarily unavailable. Please try again later');
    }

    // 🔥 IMPORTANT: rethrow
    throw {
      code: errorCode || error?.code,
      message: cachedMessage,
      status: error?.response?.status,
      raw: error,
    };
  }
};
